export const userAccountModel = {
   'username': {
      'title': "Username",
      'display': true
   },
   'password': {
      'title': "Password",
      'display': false
   },
   'first_name': {
      'title': "First Name",
      'display': true
   },
   'last_name': {
      'title': "Last Name",
      'display': true
   },
   'privilege_level': {
      'title': "Privilege Level",
      'display': true
   },
   'source': {
      'title': "Source",
      'display': true
   },
   'app_oneacl': {
      'title': "OneACL",
      'display': false
   },
   'app_onechange': {
      'title': "OneChange",
      'display': false
   },
   'app_oneeye': {
      'title': "OneEye",
      'display': false
   },
   'app_oneip': {
      'title': "OneIP",
      'display': false
   },
   'app_oneport': {
      'title': "OnePort",
      'display': false
   }
};
export const privilegeLevels = [
   "Viewer",
   "Editor",
   "Administrator"
]